export default "__VITE_ASSET__7e81dc3e__"